import { isTag } from 'anodum';
import getCollapsedNodeAndOffset from './get-collapsed-node-and-offset';
import findFirstTextNode from './find-first-text-node';
import findRootEditableElement from './find-root-editable-element';
import { findPrevEditableElement } from './find-editable-element';
import isEmptyEditableElement from '../verifiers/is-empty-editable-element';
import { LIST_ITEM } from '../constants/editable-elements';
import setCaretAtTheBeginningOfNode from './set-caret-at-the-beginning-of-node';
import setCaretInTheEndOfNode from './set-caret-in-the-end-of-node';
import isBreakElement from '../verifiers/is-break-element';
import unwrapElement from './unwrap-element';
import findClosestEditableElement from './find-closest-editable-element';
import findPrevTextContent from './find-prev-text-content';
import getElementFromNode from './get-element-from-node';

const handleBeginningOfElement = (event) => {
  const [node, offset] = getCollapsedNodeAndOffset();
  const rootEditableElement = findRootEditableElement(node);
  if (!rootEditableElement) return;
  const firstTextNode = findFirstTextNode(rootEditableElement);

  if ((firstTextNode && node !== firstTextNode) || offset > 0) return;

  const prevEditableElement = findPrevEditableElement(node);

  event.preventDefault();

  if (!prevEditableElement) return;

  if (!isTag(prevEditableElement, LIST_ITEM) && isEmptyEditableElement(prevEditableElement)) {
    prevEditableElement.replaceWith(rootEditableElement);
    setCaretAtTheBeginningOfNode(rootEditableElement);
    return;
  }

  const anchorElement = getElementFromNode(node);
  const rootNode = anchorElement.closest('[contenteditable]');
  let targetNode = prevEditableElement;

  const prevContent = findPrevTextContent(node, rootNode);

  let tempTargetNode = null;
  if (targetNode && isTag(targetNode, LIST_ITEM)) {
    targetNode = findClosestEditableElement(prevContent);
    if (isEmptyEditableElement(targetNode)) {
      targetNode.textContent = '';
      tempTargetNode = targetNode.cloneNode(true);
    }
  }

  const isPrevBreakElement = isBreakElement(prevContent);
  if (isPrevBreakElement) prevContent.remove();

  const childNodes = unwrapElement(rootEditableElement);

  if (childNodes.length === 1 && isBreakElement(childNodes[0]) && !isPrevBreakElement) {
    childNodes[0].remove();
    setCaretInTheEndOfNode(targetNode);
    return;
  }

  const fragment = document.createDocumentFragment();
  fragment.append(...childNodes);
  if (tempTargetNode) {
    tempTargetNode.appendChild(fragment);
    targetNode.replaceWith(tempTargetNode);
    setCaretAtTheBeginningOfNode(tempTargetNode);
  } else {
    setCaretInTheEndOfNode(targetNode);
    targetNode.appendChild(fragment);
  }
};

export default handleBeginningOfElement;
